import { SelectedFilter } from '../../../../types/types';
import { getColumnByFilterParam } from '../../../../utils/managerUtils';
import { isValuelessMatchMode } from '../../../../utils/filters/isValuelessMatchMode';

export const getCorrectSubmitFilters = (
  dataset: any,
  filters: SelectedFilter[] | undefined,
  selectedFilters: SelectedFilter[],
  newFilters: Record<string, any>
) => {
  let correctFilters = filters === undefined ? selectedFilters : filters;

  correctFilters = correctFilters.map((filter) => {
    // Valueless match modes carry no value; force true so stripEmptyActiveFilters keeps the filter
    if (isValuelessMatchMode(filter.matchMode)) {
      return { ...filter, value: true };
    }
    return filter;
  });

  correctFilters.forEach((item) => {
    if (item.datasetId === dataset.datasetId) {
      const columnWithThisFilter = getColumnByFilterParam(item.name, dataset);
      const lazyFilter = columnWithThisFilter
        ? newFilters[columnWithThisFilter.name]
        : undefined;
      // Filter-only technical fields are present in dataset.items with
      // visible=false, so getDefaultLazyStateFilters intentionally has no
      // PrimeReact grid constraint for them. They are still submitted through
      // correctFilters/apiObject below; only mirror filters that have a grid
      // representation into newFilters.
      if (lazyFilter?.constraints?.[0]) {
        lazyFilter.constraints[0].value = item.value;
        lazyFilter.constraints[0].matchMode = item.matchMode;
      }
    }
  });

  return correctFilters;
};
